import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PERMANENT_DISCLAIMER } from "@/data/disclaimer";
import { ShieldAlert } from "lucide-react";

const SITESEAL_SRC = "https://seal.godaddy.com/getSealBasic?sealID=C654W4pEUnM4khIwmzOqkT3KtTVJMI6VwmYH0WptSudV5yhvOJdLbhuQgAfm";

const FOOTER_LINKS = [
  { to: "/learn", key: "learn" },
  { to: "/guides", key: "guides" },
  { to: "/code", key: "codeSections" },
  { to: "/certification", key: "certification" },
  { to: "/simulator", key: "simulator" },
  { to: "/privacy", key: "privacy" },
  { to: "/terms", key: "terms" },
];

export default function Footer() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    // GoDaddy site seal injects into #siteseal; React won't run inline <script>, so load it here.
    const el = document.getElementById("siteseal");
    if (el && !el.querySelector("script")) {
      const s = document.createElement("script");
      s.async = true;
      s.type = "text/javascript";
      s.src = SITESEAL_SRC;
      el.appendChild(s);
    }
  }, []);

  return (
    <footer className="border-t border-white/10 bg-[#0B132B] mt-auto">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-wrap items-start justify-between gap-6 mb-6">
          <div className="flex items-center gap-2">
            <img src="/logo-firealarmbt-light.png" alt="FireAlarm BT — Fire Alarm Blueprint Trainer" width="702" height="209" loading="lazy" decoding="async" className="h-7 w-auto" />
          </div>
          <nav className="flex flex-wrap gap-x-5 gap-y-1" aria-label={t("footer.explore")}>
            {FOOTER_LINKS.map((l) => (
              <Link key={l.to} to={l.to === "/code" && i18n.language.startsWith("es") ? "/es/codigo" : l.to} data-testid={`footer-link-${l.to.slice(1)}`}
                className="inline-flex items-center min-h-[44px] px-1 text-sm text-slate-400 hover:text-primary transition-colors">{t(`nav.${l.key}`)}</Link>
            ))}
            <button type="button" data-testid="footer-manage-cookies"
              onClick={() => window.dispatchEvent(new Event("fab:open-cookie-consent"))}
              className="inline-flex items-center min-h-[44px] px-1 text-sm text-slate-400 hover:text-primary transition-colors">Manage cookies</button>
          </nav>
        </div>
        <div className="flex items-start gap-3 rounded-md border border-yellow-500/30 bg-yellow-500/10 p-4">
          <ShieldAlert size={20} className="text-yellow-400 shrink-0 mt-0.5" />
          <p className="text-sm text-slate-300 leading-relaxed" data-testid="footer-disclaimer">
            {PERMANENT_DISCLAIMER}
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 mt-6">
          <p className="text-xs text-slate-500 font-mono">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
          <span id="siteseal" data-testid="siteseal" />
        </div>
      </div>
    </footer>
  );
}
